import $ from "jquery";

class MenuNavigation {
    constructor() {
        this.open();
        this.close();
        this.subMenu();
    }

    subMenu() {
        const menu_header = $('.menu-header-bg');
        const menu_header_item = menu_header.find('.menu-item .menu-link');

        menu_header_item.on('mouseenter', function (e) {
            e.preventDefault();

            menu_header.addClass('active-submenu')
        });

        menu_header.on('mouseleave', function (e) {
            e.preventDefault();

            menu_header.removeClass('active-submenu')
        });
    }

    open() {
        let _this = this;
        const burger_btn = $('.burger-menu');

        burger_btn.on('click', function (e) {
            e.preventDefault();

            let side_menu = $('#side-menu');
            side_menu.removeAttr('style');

            _this.toggleMenu('open')
        })
    }

    close() {
        let _this = this;
        const close_btn = $('#side-menu .menu-close');

        close_btn.on('click', function (e) {
            e.preventDefault();
            _this.toggleMenu('close')
        })
    }

    toggleMenu(option) {
        const menu = document.querySelector('#side-menu');
        menu.classList.toggle('open');
        this.toggleBackdrop(option);
    }

    toggleBackdrop(option) {
        if (option === 'open') {
            $(document).find('body').append('<div class="block-backdrop"></div>');
            setTimeout(function () {
                $(document).find('.block-backdrop').addClass('open');
            }, 100)
        } else {
            $(document).find('.block-backdrop').removeClass('open');
            setTimeout(function () {
                $(document).find('.block-backdrop').remove();
            }, 600)
        }
    }
}

export default MenuNavigation